import React from "react";
import styles from "./ViewPlants.module.scss";
import Aside from "../../components/Aside/Aside";
import Main from "./Components/Main/Main";
import Header from "../../components/Header/Header";
import FooterClient from "../../components/FooterClient/FooterClient";

const ViewPlants = ({ currentLang, setCurrentLang }) => {
  return (
    <div className={styles.wrapper}>
      <Aside />
      <div className={styles.container}>
        <Header currentLang={currentLang} setCurrentLang={setCurrentLang} />
        <Main />
        <div className={styles.footer}>
          <FooterClient />
        </div>
      </div>
    </div>
  );
};

export default ViewPlants;
